import { MaterialStatus } from "@core/models/material-status";

export class OrderAdDetail {
	id!: string;
	packageId!: string;
	productId!: string;
	placementId!: string;
	issueDate!: string;

	// TODO: remove !

	priceGross!: number;
	discountAmount!: number;
	priceNetExComm: number | undefined;
	commissionAmount!: number;
	priceNet: number | undefined;
	materialId!: string;
	columns!: number;
	depth!: number;
	width!: number;
	moduleCode!: string;
	lines!: number;
	words!: number;
	size!: string;
	statusFlags: string[] = [];
	placementRequest?: string;
	confirmationNumber?: string;
	confirmationDeadline?: string;
	materialDeadline?: string;
	bookingDeadline?: string;
	materialStatus?: MaterialStatus;

	orderId: string | undefined; // parent order id; used in material split
}
